export default "__VITE_ASSET__CuVZAS2q__"